//amgular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

//local
import {
  ApiConstants,
  HttpParamHelper,
  HttpResult,
  PollyHttpHelper,
} from "@app/shared";

import { SecurityConfig } from '@app/core';
import { GetCatalogResponse } from '../dtos';

@Injectable({
    providedIn: 'root'
  })
export class CatalogHttpService 
{
    constructor(
      private http: HttpClient, 
      private applicationConfig: SecurityConfig) {    
    }

    public getAll(roomId?: string, departmentId?: string, programId?: string, projectId?: string, roomContentId?: string, categoryId?: string): HttpResult<GetCatalogResponse> 
    {
      const queryParams: Record<string, string | undefined> = {
        roomId,
        departmentId,
        programId,
        projectId,
        roomContentId,
        categoryId
      };

      let params = HttpParamHelper.toHttpParams(queryParams);

      let serviceUri = `${this.applicationConfig.applicationUri}/v2/catalog/carousels`;

      console.log(`GET: ${serviceUri}`, params); 
      
      return PollyHttpHelper.Invoke('GET', () => this.http.get<GetCatalogResponse>(serviceUri, { headers: ApiConstants.DefaultHeaders, params }));
    }    
}